import React, { Component } from 'react';

export default class Errors extends Component {
    render() {
        const { errors } = this.props;

        if (errors) {
            return (
                <div className="errors-box">
                    <ul>
                        { Object.keys(errors).map(function(key) {
                            return <li key={key}>{errors[key]}</li>;
                        }) }
                    </ul>
                </div>
            )
        }
        
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/partials/Errors.js